import { Box, Typography, Stack, Button } from "@mui/material";
import { styled, keyframes } from "@mui/material/styles";
import { c } from '../../../theme/colorUtils';


export const Container = styled(Box)(() => ({
  paddingBottom: 75,
  backgroundColor: c.grayLightest,
}));


/* 배너 관련 스타일 */
export const BannerContainer = styled(Box)({
  overflow: 'hidden',
  position: 'relative',
  height: '130px',
  boxSizing: 'border-box',
  marginBottom: '40px',
  overflow: 'visible',
});

export const BannerSlider = styled(Box)({
  display: 'flex',
  transition: 'transform 0.5s ease-in-out',
  height: '100%',
  overflow: 'visible',
  touchAction: 'none',
  cursor: 'grab',
  '&:active': {
    cursor: 'grabbing',
  }
});

export const BannerPagination = styled(Box)({
  position: 'absolute',
  top: '8px',
  right: '24px',
  backgroundColor: 'rgba(255, 255, 255, 0.6)',
  padding: '0 8px',
  borderRadius: 100,
  display: 'flex',
  gap: '8px',
  zIndex: 10,
});



export const BannerSlide = styled(Box)({
  minWidth: 'calc(100% - 32px)',
  height: '130px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '16px',
  position: 'relative',
  cursor: 'pointer',
  borderRadius: '24px',
  margin: '0 16px',
  overflow: 'visible',
  boxSizing: 'border-box',
  touchAction: 'none', // 터치 기본 동작 완전히 비활성화
  '&:hover': {
    transform: 'scale(1.02)',
    transition: 'transform 0.2s ease-in-out',
  }
});

export const BannerContent = styled(Box)({
  flex: 1,
  zIndex: 2,
  '& .MuiTypography-root': {
    whiteSpace: 'pre-wrap',
  }
});

export const BannerImage = styled('img')(({ isVisible }) => ({
  position: 'absolute',
  right: '-8px',
  bottom: '-8px',
  maxHeight: '110px',
  objectFit: 'contain',
  opacity: isVisible ? 1 : 0,
  zIndex: 3,
  transform: isVisible ? 'translateX(0) scale(1)' : 'translateX(80px) scale(0.7)',
  transition: 'all 0.9s cubic-bezier(0.68, -0.55, 0.265, 1.55)',
}));



/* 퀵메뉴 애니메이션 */
// 설정 아이콘 애니메이션 - 시계방향 (오른쪽으로)
const settingIconClockwise = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

// 설정 아이콘 애니메이션 - 반시계방향 (왼쪽으로)
const settingIconCounterClockwise = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(-360deg);
  }
`;

// 가이드 아이콘 애니메이션 (위아래 움직임)
const guideIconAnimation = keyframes`
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-5px);
  }
  100% {
    transform: translateY(0px);
  }
`;



/* 퀵메뉴 */
export const QuickMenuWrap = styled(Stack)(() => ({
  display: 'flex',
  flexDirection: 'row',
  gap: 8,
  padding: '0 16px',
}));

export const QuickMenuBox = styled(Button)(() => ({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  padding: 16,
  gap: 8,
  borderRadius: '24px',
  justifyContent: 'space-between',
  alignItems: 'center',
  minHeight: '132px',
  boxSizing: 'border-box',
  cursor: 'pointer',
  backgroundColor: c.bg,
  '& .IconBox': {
    width: '40px',
    height: '40px',
    position: 'relative',
  },
  // 설정 아이콘 애니메이션 (첫 번째 박스)
  '&.quickMenuBox01 img.PokoroSetting_1': {
    width: '24px',
    height: '24px',
    position: 'absolute',
    bottom: '2px',
    left: '2px',
    animation: `${settingIconClockwise} 7s linear infinite`,
  },
  '&.quickMenuBox01 img.PokoroSetting_2': {
    width: '16px',
    height: '16px',
    position: 'absolute',
    top: '7px',
    right: '0px',
    animation: `${settingIconCounterClockwise} 5s linear infinite`,
  },
  // 가이드 아이콘 애니메이션 (두 번째 박스)
  '&.quickMenuBox02 img': {
    animation: `${guideIconAnimation} 2s ease-in-out infinite`,
  },
}));

/* 포코로 목록 */
export const PokoroListCard = styled(Stack)(() => ({
  padding: '0px 16px',
  paddingBottom: 16,
  position: 'relative',
  gap: 16,
  '& .ListBox': {
    padding: '0 8px',
    height: '54px',
    border: `1px solid ${c.grayHard}`,
    borderRadius: '8px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  }
}));

export const HomeContBox = styled(Stack)(() => ({
  boxSizing: 'border-box',
  borderRadius: '24px',
  backgroundColor: c.bg,
}));


/* 달력 */
export const CalendarWrap = styled(Stack)(() => ({
  gap: '16px',
  padding: "0 16px",
}));

export const CalendarToggleButton = styled(Button)(() => ({
  fontSize: "0.75rem",
  color: `${c.text01}`,
  borderColor: "transparent",
  padding: 8,
  transition: 'all 0.3s ease',
  '& svg': {
    transition: 'transform 0.3s ease',
  },
  '&:hover, &:focus-visible, &:focus': {
    backgroundColor: 'transparent!important',
    border: '0!important',
  }
}));

/* 사용현황, 발음평가, 관심키워드 - 공통 */
export const TodaySituation = styled(Stack)({
  gap: '1rem',
  padding: '0 16px',
});

export const BoxWrap = styled(Stack)({
  justifyContent: 'space-between',
})

export const MoreButton = styled(Button)(() => ({
  width: "100%",
  display: "flex",
  justifyContent: "center",
  fontSize: "0.875rem",
  color: `${c.text02}`,
  "&:hover": {
    backgroundColor: "transparent",
  },
}));

/* 사용현황 */
export const StatusBox = styled(Stack)({
  flexDirection: 'column',
  marginBottom: '24px',
  gap: '24px',
});

export const UsageCard = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
});

export const UsageCardHeader = styled(Stack)({
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  '& img': {
    width: '24px',
    height: '24px',
  }
});

export const UsageProgressBar = styled(Box)(({ progress, maxProgress, barColor = c.primary }) => ({
  width: '100%',
  height: '16px',
  backgroundColor: c.grayLightest,
  borderRadius: '4px',
  overflow: 'hidden',
  position: 'relative',
  '&::after': {
    content: '""',
    position: 'absolute',
    left: 0,
    top: 0,
    height: '100%',
    width: `${Math.min((progress / maxProgress) * 100, 100)}%`,
    backgroundColor: barColor,
    borderRadius: '4px',
    transition: 'width 1.5s cubic-bezier(0.4, 0, 0.2, 1)',
  }
}));

/* 관심키워드 */
export const KeywordCloud = styled(Box)({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center',
  gap: '8px',
  padding: '16px 0',
});


export const Keyword = styled(Typography)({
  fontSize: '14px',
  color: '#666',
});


/* 디바이스 스와이프 관련 스타일 - 배너와 동일한 좌우 16px 여백 */
export const DeviceSwipeContainer = styled(Box)({
  position: 'relative',
  width: '100%',
  overflow: 'hidden',
  padding: '0 16px 32px 16px',
  boxSizing: 'border-box',
});

export const DeviceSlider = styled(Box)({
  display: 'flex',
  cursor: 'grab',
  userSelect: 'none',
  touchAction: 'pan-y pinch-zoom',
  '&:active': {
    cursor: 'grabbing',
  }
});

export const DeviceSlide = styled(Box)(({ slideWidth }) => ({
  width: slideWidth ? `${slideWidth}px` : '100%',
  marginRight: 8,
  display: 'flex',
  flexShrink: 0,

  '&:last-child': {
    marginRight: 0,
  }
}));

export const PaginationContainer = styled(Box)({
  position: 'absolute',
  bottom: '8px',
  left: '50%',
  transform: 'translateX(-50%)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '8px',
  zIndex: 10,
});

export const PaginationDot = styled(Box)(({ active }) => ({
  width: '8px',
  height: '8px',
  borderRadius: '50%',
  backgroundColor: active ? c.primary : c.grayHard,
  opacity: active ? 1 : 0.4,
  cursor: 'pointer',
  transition: 'all 0.3s ease',
  transform: active ? 'scale(1.2)' : 'scale(1)',

  '&:hover': {
    opacity: 0.7,
    transform: 'scale(1.1)',
  }
}));

export const DeviceCard = styled(Stack)(({ isSelected }) => ({
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'center',
  position: 'relative',
  width: '100%',
  padding: '18px 24px',
  borderRadius: 24,
  backgroundColor: c.bg,
  border: isSelected ? `2px solid ${c.primary}` : `1px solid ${c.grayLighter}`,
  cursor: 'pointer',
  transition: 'all 0.2s ease',
  gap: 10,
  minHeight: '120px',
  boxSizing: 'border-box',
  overflow: 'visible',
}));

export const DeviceImage = styled('img')({
  width: 75,
  height: 100,
  objectFit: 'cover',
  objectPosition: 'top',
});

export const ProfileSetupButton = styled(Box)({
  width: '100%',
  height: 40,
  borderRadius: 8,
  border: `1px dashed ${c.grayHard}`,
  backgroundColor: c.bg,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: c.text01,
  fontWeight: 700,
  fontSize: '15px',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: c.grayLightest,
  },
});

export const ProfileGuideBubble = styled(Box)({
  position: 'absolute',
  width: '110%',  
  left: '50%',
  bottom: -40,
  transform: 'translateX(-50%)',
  maxWidth: 'calc(100% + 24px)',
  padding: '4px',
  borderRadius: 16,
  backgroundColor: c.bg02,
  border: `1px solid ${c.primary}`,
  color: c.text01,
  fontSize: '12px',
  textAlign: 'center',
  boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: -8,
    left: '50%',
    transform: 'translateX(-50%)',
    borderLeft: '8px solid transparent',
    borderRight: '8px solid transparent',
    borderBottom: `8px solid ${c.primary}`,
  },
});

export const AddDeviceCard = styled(Box)({
  width: '100%',
  padding: '16px',
  borderRadius: '16px',
  backgroundColor: c.bg,
  cursor: 'pointer',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '8px',
  minHeight: '120px',
  boxSizing: 'border-box',
  '&:hover > div': {
    backgroundColor: c.primary,
    color: c.bg,
  }
});

export const AddDeviceIcon = styled(Box)({
  width: '32px',
  height: '32px',
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: c.text02,
  transition: 'all 0.2s ease',
});

export const SelectedBadge = styled(Box)(({ isSelected, isDisabled }) => ({
  position: 'absolute',
  top: '-4px',
  right: '-4px',
  width: '48px',
  height: '48px',
  borderRadius: '50%',
  backgroundColor: 'transparent',
  color: '#fff',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 1,
  transition: 'all 0.2s ease',
  cursor: isDisabled ? 'not-allowed' : 'pointer',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: '50%',
    left: '50%',
    width: '24px',
    height: '24px',
    borderRadius: '50%',
    backgroundColor: isSelected ? c.primary : c.grayLight,
    transform: 'translate(-50%, -50%)',
    transition: 'all 0.2s ease',
    zIndex: 0,
  },
  '& > *': {
    position: 'relative',
    zIndex: 1,
  },
}));

export const FireworkContainer = styled(Box)(({ trigger }) => ({
  position: 'absolute',
  top: '8px',
  right: '8px',
  width: '24px',
  height: '24px',
  pointerEvents: 'none',
  zIndex: 2,

  '&::before, &::after': {
    content: '""',
    position: 'absolute',
    top: '50%',
    left: '50%',
    width: '4px',
    height: '4px',
    borderRadius: '50%',
    backgroundColor: c.primary,
    opacity: 0,
    transform: 'translate(-50%, -50%)',
  },

  ...(trigger && {
    '&::before': {
      animation: 'firework1 0.6s ease-out',
    },
    '&::after': {
      animation: 'firework2 0.6s ease-out 0.1s',
    },
  }),

  '@keyframes firework1': {
    '0%': {
      opacity: 1,
      transform: 'translate(-50%, -50%) scale(1)',
    },
    '50%': {
      opacity: 0.8,
      transform: 'translate(-50%, -50%) scale(3)',
    },
    '100%': {
      opacity: 0,
      transform: 'translate(-50%, -50%) scale(5)',
    },
  },

  '@keyframes firework2': {
    '0%': {
      opacity: 1,
      transform: 'translate(-50%, -50%) scale(1)',
      boxShadow: `
        0 0 0 2px ${c.primary},
        10px 0 0 1px ${c.primary},
        -10px 0 0 1px ${c.primary},
        0 10px 0 1px ${c.primary},
        0 -10px 0 1px ${c.primary},
        7px 7px 0 1px ${c.primary},
        -7px -7px 0 1px ${c.primary},
        7px -7px 0 1px ${c.primary},
        -7px 7px 0 1px ${c.primary}
      `,
    },
    '50%': {
      opacity: 0.6,
      transform: 'translate(-50%, -50%) scale(2)',
      boxShadow: `
        0 0 0 1px ${c.primary},
        20px 0 0 1px ${c.primary},
        -20px 0 0 1px ${c.primary},
        0 20px 0 1px ${c.primary},
        0 -20px 0 1px ${c.primary},
        14px 14px 0 1px ${c.primary},
        -14px -14px 0 1px ${c.primary},
        14px -14px 0 1px ${c.primary},
        -14px 14px 0 1px ${c.primary}
      `,
    },
    '100%': {
      opacity: 0,
      transform: 'translate(-50%, -50%) scale(3)',
      boxShadow: `
        0 0 0 0 ${c.primary},
        30px 0 0 0 ${c.primary},
        -30px 0 0 0 ${c.primary},
        0 30px 0 0 ${c.primary},
        0 -30px 0 0 ${c.primary},
        21px 21px 0 0 ${c.primary},
        -21px -21px 0 0 ${c.primary},
        21px -21px 0 0 ${c.primary},
        -21px 21px 0 0 ${c.primary}
      `,
    },
  },
}));



